import { gql } from "graphql-request";

export const GET_AGENCIES_SALES_DETAILS = gql`
  query GetAgenciesSalesDetails(
    $take: Int
    $skip: Int
    $userId: Int
    $dateInitial: String
    $dateFinal: String
  ) {
    getAgenciesSalesDetails(
      take: $take
      skip: $skip
      userId: $userId
      dateInitial: $dateInitial
      dateFinal: $dateFinal
    ) {
      status
      error
      data {
        id
        agencyId
        userId
        coins
        dateSentCoin
        dateReceivedCoin
        createdAt
        userUsername
        userImgUser
        reversedAt
        isAgency
      }
    }
  }
`;

export const GET_AGENCIES_SALES_DETAILS_TOTAL = gql`
  query GetAgenciesSalesDetailsTotal(
    $dateTimeInitial: String
    $dateTimeFinal: String
  ) {
    getAgenciesSalesDetailsTotal(
      dateTimeInitial: $dateTimeInitial
      dateTimeFinal: $dateTimeFinal
    ) {
      status
      error
      data {
        total
        count
      }
    }
  }
`;

// ⚠️ O gateway espalha `body.variables` cru pro worker: o nome da variável
// GraphQL TEM que bater com o nome do argumento (`$saleId` -> `saleId`).
export const REVERSE_AGENCY_SALE_DETAIL = gql`
  mutation REVERSE_AGENCY_SALE_DETAIL($saleId: Int!) {
    reverseAgencySaleDetail(saleId: $saleId) {
      error
      status
      data {
        id
        coins
        reversed
      }
    }
  }
`;

export const CREATE_AGENCY_SALE_DETAIL = gql`
  mutation CREATE_AGENCY_SALE_DETAIL(
    $agencyId: Int!
    $userId: Int!
    $coins: Float!
    $isAgency: Boolean!
  ) {
    createAgencySaleDetail(
      agencyId: $agencyId
      userId: $userId
      coins: $coins
      isAgency: $isAgency
    ) {
      error
      status
      data
    }
  }
`;

// Totals of the WHOLE filtered history (same filters as the list).
export const GET_AGENCIES_SALES_DETAILS_SUMMARY = gql`
  query getAgenciesSalesDetailsSummary(
    $userId: Int
    $dateInitial: String
    $dateFinal: String
  ) {
    getAgenciesSalesDetailsSummary(
      userId: $userId
      dateInitial: $dateInitial
      dateFinal: $dateFinal
    ) {
      status
      error
      data
    }
  }
`;

// Every row of the filtered history, for the Excel/PDF download.
export const GET_AGENCIES_SALES_DETAILS_EXPORT = gql`
  query getAgenciesSalesDetailsExport(
    $userId: Int
    $dateInitial: String
    $dateFinal: String
  ) {
    getAgenciesSalesDetailsExport(
      userId: $userId
      dateInitial: $dateInitial
      dateFinal: $dateFinal
    ) {
      status
      error
      data
    }
  }
`;

// Seller statement: sales + conversions + reversals + every other stock movement,
// from the agency coin ledger (balance after each one).
export const GET_AGENCY_SELLER_STATEMENT = gql`
  query getAgencySellerStatement(
    $take: Int
    $skip: Int
    $userId: Int
    $dateInitial: String
    $dateFinal: String
  ) {
    getAgencySellerStatement(
      take: $take
      skip: $skip
      userId: $userId
      dateInitial: $dateInitial
      dateFinal: $dateFinal
    ) {
      status
      error
      data
    }
  }
`;

export const GET_AGENCY_SELLER_STATEMENT_EXPORT = gql`
  query getAgencySellerStatementExport(
    $userId: Int
    $dateInitial: String
    $dateFinal: String
  ) {
    getAgencySellerStatementExport(
      userId: $userId
      dateInitial: $dateInitial
      dateFinal: $dateFinal
    ) {
      status
      error
      data
    }
  }
`;
